import { useEffect, useState } from 'react';
import { api, type HelperDigestSettings } from '../api';
import { Dropdown } from '../components/Dropdown';

/*
 * Блок «Утренняя сводка от Педро» в личном кабинете: переключатель «Присылать»
 * и время (по Москве, шаг 30 минут, 7:00–12:00). Настройка хранится на
 * сервере и одинакова на телефоне и компьютере; каждое изменение сохраняется
 * сразу (дизайн-система 3.5: переключатель срабатывает сразу).
 */

const TIMES = Array.from({ length: 11 }, (_, i) => {
  const minutes = 7 * 60 + i * 30;
  const t = `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${minutes % 60 ? '30' : '00'}`;
  return { value: t, label: t };
});

export function DigestCard() {
  const [s, setS] = useState<HelperDigestSettings | null>(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.helperDigest().then(setS).catch(() => setErr('Не удалось загрузить настройку'));
  }, []);

  const change = async (next: HelperDigestSettings) => {
    const prev = s;
    setS(next);
    setErr('');
    try {
      setS(await api.saveHelperDigest(next));
    } catch {
      setS(prev);
      setErr('Не удалось сохранить настройку');
    }
  };

  return (
    <section className="card form">
      <h2>Утренняя сводка от Педро</h2>
      <p className="sub">Каждый рабочий день Педро напишет вам в чат, какие у вас сегодня задания и встречи.</p>
      {s && (
        <>
          <label className="check">
            <span className="row-title">Присылать</span>
            <span className="switch">
              <input
                type="checkbox"
                aria-label="Присылать"
                checked={s.enabled}
                onChange={(e) => void change({ ...s, enabled: e.target.checked })}
              />
              <i />
            </span>
          </label>
          <div className="field">
            <label htmlFor="prof-digest-time" className="field-label">
              Время, по Москве
            </label>
            <Dropdown
              id="prof-digest-time"
              value={s.time}
              options={TIMES}
              disabled={!s.enabled}
              onChange={(time) => void change({ ...s, time })}
            />
          </div>
        </>
      )}
      {err && <div className="banner crit">{err}</div>}
    </section>
  );
}
